// device.ts
export type DeviceType = "ios" | "android" | "web";

export function detectDeviceType(): DeviceType {
  // 1) query param
  try {
    const sp = new URLSearchParams(window.location.search);
    const qp = sp.get("platform")?.toLowerCase();
    if (qp === "ios" || qp === "android" || qp === "web") return qp;
  } catch { /* empty */ }

  // 2) injected (네이티브에서 주입)
  const injected = (window as { __DEVICE_TYPE__?: string }).__DEVICE_TYPE__;
  if (injected === "ios" || injected === "android" || injected === "web") {
    return injected;
  }

  // 3) UA fallback
  const ua = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(ua)) return "ios";
  if (/android/.test(ua)) return "android";
  // iPadOS Safari는 데스크톱 UA로 위장하므로(맥 UA + 멀티터치) 별도 보정
  if (/macintosh/.test(ua) && navigator.maxTouchPoints > 1) return "ios";
  return "web";
}